export default __webpack_public_path__ + "static/media/cr2.806bfbf5.jpg";